import React from 'react';
import { formatMetricName } from './formatters';

// Custom tooltip for charts
export const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const dataPoint = payload[0]?.payload;
    const isEmpty = dataPoint?.isEmptyData;
    
    return (
      <div className="custom-tooltip bg-dark text-white p-3 rounded shadow" style={{ maxWidth: '350px' }}>
        <p className="mb-1"><strong>{dataPoint?.displayTime}</strong></p>
        {isEmpty ? (
          <p className="mb-1 text-warning"><em>No data available for this time period</em></p>
        ) : (
          <>
            <p className="mb-1 small">Aggregation: {dataPoint?.aggregation}</p>
            <p className="mb-1 small text-truncate" style={{ maxWidth: '330px' }}>
              {dataPoint?.timeRange}
            </p>
            <hr className="my-2" />
            {payload.map((entry, index) => (
              <p key={index} className="mb-0" style={{ color: entry.color }}>
                {formatMetricName(entry.dataKey)}: {entry.value}
              </p>
            ))}
            {dataPoint?.dataPoints && (
              <>
                <hr className="my-2" />
                <p className="mb-0 small">
                  Data Points: 
                  R:{dataPoint.dataPoints.respiratory} 
                  H:{dataPoint.dataPoints.heart} 
                  E:{dataPoint.dataPoints.energy} 
                  HRV:{dataPoint.dataPoints.hrv}
                </p>
                <p className="mb-0 small text-info">
                  <em>Displaying calculated averages</em>
                </p>
              </>
            )}
          </>
        )}
      </div>
    );
  }
  return null;
};

// Custom legend with better formatting
export const renderCustomizedLegend = (props) => {
  const { payload } = props;
  return (
    <div className="d-flex justify-content-center flex-wrap gap-3 mt-3">
      {payload.map((entry, index) => (
        <div key={`item-${index}`} className="d-flex align-items-center">
          <div 
            className="legend-color me-2" 
            style={{ 
              backgroundColor: entry.color, 
              width: '15px', 
              height: '15px',
              borderRadius: '3px'
            }}
          />
          <span className="small">{formatMetricName(entry.value)}</span>
        </div>
      ))}
    </div>
  );
};